export { DesignBadge } from "@hexclave/dashboard-ui-components";
export type { DesignBadgeColor, DesignBadgeSize, DesignBadgeContentMode, DesignBadgeProps } from "@hexclave/dashboard-ui-components";
